import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BottomNav from "../components/BottomNav";
import InternalHeader from "../components/InternalHeader";
import { useAppState } from "../context/AppState";
import { authenticatedApi } from "../lib/api";

export default function AlertsPage() {
  const { user } = useAppState();
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(Boolean(user));
  const [error, setError] = useState("");

  useEffect(() => {
    if (!user?.auth_token) return;
    authenticatedApi("/get-user-notifications", user.auth_token, {
      method: "POST",
      body: "{}",
    })
      .then((response) => {
        const rows = Array.isArray(response) ? response : response?.data || [];
        setAlerts(Array.isArray(rows) ? rows : []);
      })
      .catch((requestError) => setError(requestError.message))
      .finally(() => setLoading(false));
  }, [user]);

  async function markAllRead() {
    if (!user?.auth_token) return;
    await authenticatedApi("/mark-all-notifications-read", user.auth_token, {
      method: "POST",
      body: "{}",
    });
    setAlerts((current) => current.map((alert) => ({ ...alert, is_read: 1, read_at: true })));
  }

  return (
    <main className="food-app">
      <InternalHeader
        title="Alertas"
        backTo="/food"
        action={alerts.length > 0 ? <button type="button" onClick={markAllRead}>Marcar leídas</button> : null}
      />
      <div className="alerts-page">
        {!user && (
          <section className="empty-cart">
            <span>🔔</span>
            <h2>Inicia sesión para ver tus alertas</h2>
            <Link to="/account?next=/alerts">Ir a mi cuenta</Link>
          </section>
        )}
        {loading && <div className="food-message"><b>Cargando alertas…</b></div>}
        {error && <div className="food-message food-message--error"><b>{error}</b></div>}
        {!loading && user && !error && alerts.length === 0 && (
          <section className="empty-cart">
            <span>✓</span>
            <h2>No tienes alertas nuevas</h2>
            <p>Aquí aparecerán los cambios de tus pedidos y promociones.</p>
          </section>
        )}
        <section className="alert-list">
          {alerts.map((alert) => (
            <article className={`alert-card ${alert.is_read || alert.read_at ? "" : "is-new"}`} key={alert.id}>
              <span>🔔</span>
              <div>
                <small>{alert.created_at || ""}</small>
                <h2>{alert.title || alert.data?.title || "Delivery Huaraz"}</h2>
                <p>{alert.message || alert.data?.message || alert.body || "Tienes una nueva notificación."}</p>
              </div>
            </article>
          ))}
        </section>
      </div>
      <BottomNav />
    </main>
  );
}
